<article class="box_default box_white">
  <!-- HEADER -->
  <header>
    <h3>Generate new token</h3>
  </header>
  <!-- END HEADER -->
  <!-- BODY -->
  <div *ngIf="!newAccessToken" class="box_main">
    <form [formGroup]="form">
      <span class="txt_error" *ngIf="errorAddToken">{{textError}}</span>
      <!--  -->
      <div class="box_item">
        <label class="box-label">TOKEN DESCRIPTION</label>
          <input type="text" placeholder="What is this token for?" formControlName="name"/>
      </div>
      <div class="box_item box_item_checkboxes">
        <core-helpers-forms-input-checkbox
          [label]="'Read only?'"
          [name]="'readonly'"
          [defaultChecked]="false"
          [form]="form"
          (checkedChange)="onReadOnlyChange($event)"
          ></core-helpers-forms-input-checkbox>
      </div>
      <div class="box_fieldset">
        <core-helpers-forms-button-white [text]="'Save'" [disabled]="form.invalid || buttonDisabled || errorLowerCase" (click)= "addAccessToken()"></core-helpers-forms-button-white>
        <core-helpers-forms-button [type]="'grey'" [text]="'Cancel'" (click)="onCancel()"></core-helpers-forms-button>
      </div>
    </form>
  </div>
  <settings-access-tokens-new *ngIf="newAccessToken"
      [accessToken]="newAccessToken"
      (done)="done()"
      ></settings-access-tokens-new>
</article>
